<template>
<div >  
   
    <div v-if="historial">
       <b-button class="first" id="btnWeek" @click="ChangeWeek('Actual')"  :class="{ active : btnsemana == 'Actual'}"    >Actual</b-button>
      <b-button  v-if=" validateDia()" id="btnWeek" @click="ChangeWeek('Anterior')">{{this.smn(lastweek.semana)}}</b-button>
       <b-button  v-if=" !validateDia()"  id="btnWeek" @click="ChangeWeek('2'), getWeek2(lastweek.semana)">{{this.smn(lastweek.semana)}}</b-button> 
       <b-button  id="btnWeek" @click="ChangeWeek('1')">{{this.smn(historial[0].semana)}}</b-button> 
    </div>
    <div v-else>
        <b-button class="first" id="btnWeek" @click="ChangeWeek('Actual')"  :class="{ active : btnsemana == 'Actual'}"    >Actual</b-button>
        <b-button  v-if=" validateDia()"  id="btnWeek" @click="ChangeWeek('Anterior')">{{this.smn(lastweek.semana)}}</b-button>       
        <b-button  v-if="!validateDia()" id="btnWeek" @click="ChangeWeek('2'),getWeek2(lastweek.semana)">{{this.smn(lastweek.semana)}}</b-button>   
    </div>
   <div id="buscar-fecha">
        <b-input v-model="fecha"  id="btnWeek" class="input-fecha" type="date" min="2021-08-30" :max="day()" ></b-input>
        
        <b-button v-if="fecha!=''" id="btnWeek" @click="getWeek()">Buscar</b-button>    
   </div>



<!--<p>hola {{this.lastweek}}</p>-->
<div v-if="btnsemana == 'Anterior'">
    <div v-if="lastweek.active == true">
        <div v-if="lastweek.statusDepto == 'Inactivo'" class="inactive-class" 
        style="display:flex;color:#005cc3;margin-left:4rem;margin-top:2.2rem;margin-bottom:3rem;">
            <img src="../assets/error-file.png" style="width:4.4rem;height:4.5rem;margin-top:.7rem;">
            <h5 style="margin-left:1.5rem;margin-top:2rem;">Este departamento no se encuentra<br>
            activo en la base de datos.</h5>  
        </div>

         <b-row class="px-5 pt-3 pb-3" id="pilas-form-admin">  
            

            <b-col  v-if="!(this.depName == 'Mantenimiento' ||this.depName == 'Vigueta'  ||this.depName == 'Insulpanel' || this.depName == 'Bono Garantía' ) && prod" class="bg-white p-4 col-6 adminPila pila-prod  mb-4" >
                <b-row class="produccion">
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #005cc3;"></div></b-col>
                    <b-col class="pl-3 pr-5 colprod">
                        <p class="stylingTitle">Producción </p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Lunes</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Martes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5" style="color: #838383;">Miércoles </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Jueves </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Viernes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Sábado</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Domingo</p></strong></th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1 " style="color: #fd832d;">
                                                     <template v-if="lastweek.prod.lunes > 0"> {{lastweek.prod.lunes | rand}}</template>
                                                    <template v-else>{{lastweek.prod.lunes }}</template>    
                                                </li>
                                            </ul>
                                            
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">                                            
                                                     <template v-if="lastweek.prod.martes > 0"> {{lastweek.prod.martes | rand}}</template>
                                                    <template v-else>{{lastweek.prod.martes }}</template>                                         
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="lastweek.prod.miercoles > 0"> {{lastweek.prod.miercoles | rand}}</template>
                                                    <template v-else>  {{lastweek.prod.miercoles}}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="lastweek.prod.jueves > 0"> {{lastweek.prod.jueves | rand}}</template>
                                                    <template v-else> {{lastweek.prod.jueves }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                   <template v-if="lastweek.prod.viernes > 0"> {{lastweek.prod.viernes | rand}}</template>
                                                    <template v-else>  {{lastweek.prod.viernes }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="lastweek.prod.sabado > 0"> {{lastweek.prod.sabado | rand}}</template>
                                                    <template v-else>  {{lastweek.prod.sabado }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="lastweek.prod.domingo > 0"> {{lastweek.prod.domingo | rand}}</template>
                                                    <template v-else>  {{lastweek.prod.domingo }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                    </b-col>
                </b-row>                       
            </b-col>  
              <b-col  v-if="lastweek.colaboradores" class="bg-white p-4 col-6 adminPila pila-prod  mb-4" >
                <b-row class="produccion">
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #ffc107;"></div></b-col>
                    <b-col class="pl-3 pr-5 colprod">
                        <p class="stylingTitle">Colaboradores</p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Lunes</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Martes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5" style="color: #838383;">Miércoles </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Jueves </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Viernes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Sábado</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Domingo</p></strong></th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1 " style="color: #fd832d;">
                                                     <template v-if="lastweek.colaboradores.lunes > 0"> {{lastweek.colaboradores.lunes | rand}}</template>
                                                    <template v-else>{{lastweek.colaboradores.lunes }}</template>    
                                                </li>
                                            </ul>
                                            
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">                                            
                                                     <template v-if="lastweek.colaboradores.martes > 0"> {{lastweek.colaboradores.martes | rand}}</template>
                                                    <template v-else>{{lastweek.colaboradores.martes }}</template>                                         
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="lastweek.colaboradores.miercoles > 0"> {{lastweek.colaboradores.miercoles | rand}}</template>
                                                    <template v-else>  {{lastweek.colaboradores.miercoles}}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="lastweek.colaboradores.jueves > 0"> {{lastweek.colaboradores.jueves | rand}}</template>
                                                    <template v-else> {{lastweek.colaboradores.jueves }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                   <template v-if="lastweek.colaboradores.viernes > 0"> {{lastweek.colaboradores.viernes | rand}}</template>
                                                    <template v-else>  {{lastweek.colaboradores.viernes }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="lastweek.colaboradores.sabado > 0"> {{lastweek.colaboradores.sabado | rand}}</template>
                                                    <template v-else>  {{lastweek.colaboradores.sabado }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="lastweek.colaboradores.domingo > 0"> {{lastweek.colaboradores.domingo | rand}}</template>
                                                    <template v-else>  {{lastweek.colaboradores.domingo }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                    </b-col>
                </b-row>                       
            </b-col>  
            
            <b-col  v-if="this.depName == 'Mantenimiento'" class="bg-white p-4 col-6 adminPila pila-prod  mb-4" >
                <b-row class="produccion">
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #005cc3;"></div></b-col>
                    <b-col class="pl-3 pr-5 colprod">
                        <p class="stylingTitle">Montos recibidos por área</p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Area</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Monto </p></strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                 <li v-for="item in lastweek.areas" :key="item.id" class="stylingSmall5 mb-1" style="color: #005cc3;">                                            
                                                    <template >{{item}}</template>                                               
                                                 </li>
                                            </ul>
                                            
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li v-for="item in lastweek.montos_recibidos_area" :key="item.id" class="stylingSmall5 mb-1" style="color: #fd832d;">                                            
                                                    <template v-if="item && item > 0">{{item | rand }}</template>
                                                    <template v-else>{{item}}</template>                                                    
                                                </li>
                                            </ul>
                                        </td>
                                      
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                        <div v-if="city =='Juárez'" class="stylingSmall6" >
                            <p> <span style="color:#838383;">Corte Construcción:</span > <span style="color:#bcbcbc; "> Promedio <span style="color: #838383;"> &#10142;</span> Electrolux, Corte, Placa, Aligerante. </span> </p>
                            <p> <span style="color: #838383;">Corte Maquila:</span>  <span style="color: #bcbcbc;">Promedio <span style="color: #838383;"> &#10142;</span> Aos Mith, Commscope, Mcs Frame.</span> </p>
                        </div>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.semana}}</p>
                        </div>
                    </b-col>
                      
                </b-row>                       
            </b-col> 
             
            <b-col v-else-if="depName == 'Bono Garantía'" class="bg-white p-4 col-12 mb-4 adminPila2" >   
                <b-row>
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales </p>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">Monto Base: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.pago_base}}</p>
                        </div>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.semana}}</p>
                        </div>
                    </b-col>                            
                </b-row>                                                     
            </b-col>  
            
            <b-col  class="bg-white p-4 col-12 mb-4 adminPila2"   v-else-if="depName == 'Vigueta'">
                     <b-row>
                        
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales </p>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">Monto base diario: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.pago_dia}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">Dias sucios: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.dias_sucios}}</p>
                        </div>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.semana}}</p>
                        </div>
                    </b-col>                            
                </b-row>  
                
                    
            </b-col >

            
                 
           
               <b-col class="bg-white p-4 col-12 mb-4 adminPila2"   v-else-if="depName == 'Insulpanel' && city=='Guadalajara'">   
                <b-row>
                        
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales </p>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">Monto base: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.pago_base}}</p>
                        </div>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.semana}}</p>
                        </div>
                    </b-col>                            
                </b-row>                 
                                                                    
               </b-col>        
           
            
                 
             
               <b-col class="bg-white p-4 col-12 mb-4 adminPila" v-else-if="(depName == 'Insulpanel' && city=='Hermosillo')|| (depName == 'Insulpanel' && city=='Mexicali')" >   
                <b-row>
                   
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2">Montos base por nivel de carrera  </p>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">NI: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.pago_base.NI}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">N1: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.pago_base.N1}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">N2: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.pago_base.N2}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">N3: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.pago_base.N3}}</p>
                        </div>
                        <div class="row ml-1" v-if="depName == 'Insulpanel' && city=='Hermosillo'">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">N4: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.pago_base.N4}}</p>
                        </div>
                      
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.semana}}</p>
                        </div>

                         <!-- montos por nivel carrera-->
                    </b-col>                            
                </b-row>                    
                                                                    
               </b-col>        
          
          
             <b-col v-if="!(this.depName == 'Mantenimiento' ||this.depName == 'Vigueta'  ||this.depName == 'Insulpanel' || this.depName == 'Bono Garantía' )" class="bg-white p-4 col-12 mb-4 adminPila" >   
                <b-row>
                   
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales  </p>
                       <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Base 0: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.base0}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Dias sucios: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.dias_sucios}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">$ Extra: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.extram3}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{lastweek.semana}}</p>
                        </div>

                    </b-col>                            
                </b-row>                                                     
            </b-col>
            
            <b-col class="bg-white p-4 col-6 adminPila" >
               
                <b-row>
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #00c290;"></div></b-col>
                    <b-col class="pl-3">
                        <p class="stylingTitle">Colaboradores </p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Nombre: </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Bono al día: </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Asistencia: </p></strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul>
                                                <li v-for="item in lastweek.equipo" :key="item.id" class="stylingSmall mb-1">
                                                    <template>{{item.nombre | cap }} </template>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul style="list-style-type: none;">
                                                <li v-for="item in lastweek.bonoSA" :key="item.id" class="stylingSmall mb-1" style="color: #fd832d;">                                            
                                                    <template v-if="item  && item >0">$ {{item | rand }}</template>
                                                    <template v-else>$ 0</template>                                                    
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul style="list-style-type: none;">
                                                <li v-for="item in lastweek.asisSA" :key="item.id" class="stylingSmall mb-1" style="color: #fd832d;">
                                                    {{item}}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                    </b-col>
                </b-row>                       
            </b-col>
            
        </b-row>      
    </div>
     <div v-else class="message-lastweek-prox">
         <p class="message-lastweek-icon">&#9881; <span class="littleicon">&#9881;</span> </p>
         <p class="message-lastweek">Próximamente...</p>
     </div>
</div>  <!------      FIN SEMANA ANTERIOR ---->
<div v-else-if="btnsemana == '1'">
    <HistorialSemanas :historial="historial[0]"/>
</div>
<div v-else-if="btnsemana == '2'">
    <HistorialSemanasDinamica :historial="dinweek2"/>
</div>   <!------      FIN SEMANA 2 ---->
<div v-else-if="btnsemana == 'Dinamica'">
    <HistorialSemanasDinamica :historial="dinweek"/>
</div>  <!------      FIN SEMANA 2 ---->
<div v-else>
        
        
        <div v-if="statusDepto == 'Inactivo'" class="inactive-class" 
        style="display:flex;color:#005cc3;margin-left:4rem;margin-top:2.2rem;margin-bottom:3rem;">
            <img src="../assets/error-file.png" style="width:4.4rem;height:4.5rem;margin-top:.7rem;">
            <h5 style="margin-left:1.5rem;margin-top:2rem;">Este departamento no se encuentra<br>
            activo en la base de datos.</h5>  
        </div>

       
        <b-row class="px-5 pt-3 pb-3" id="pilas-form-admin">  
            <b-col  v-if="this.depName == 'Mantenimiento'" class="bg-white p-4 col-6 adminPila pila-prod  mb-4" >
                <b-row class="produccion">
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #005cc3;"></div></b-col>
                    <b-col class="pl-3 pr-5 colprod">
                        <p class="stylingTitle">Montos recibidos por área</p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Area</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Monto </p></strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                 <li v-for="item in areas" :key="item.id" class="stylingSmall5 mb-1" style="color: #005cc3;">                                            
                                                    <template >{{item}}</template>                                               
                                                 </li>
                                            </ul>
                                            
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li v-for="item in montos_areas" :key="item.id" class="stylingSmall5 mb-1" style="color: #fd832d;">                                            
                                                    <template v-if="item && item > 0">{{item | rand }}</template>
                                                    <template v-else>{{item}}</template>                                                    
                                                </li>
                                            </ul>
                                        </td>
                                      
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                        <div v-if="city =='Juárez'" class="stylingSmall6" >
                            <p> <span style="color:#838383;">Corte Construcción:</span > <span style="color:#bcbcbc; "> Promedio <span style="color: #838383;"> &#10142;</span> Electrolux, Corte, Placa, Aligerante. </span> </p>
                            <p> <span style="color: #838383;">Corte Maquila:</span>  <span style="color: #bcbcbc;">Promedio <span style="color: #838383;"> &#10142;</span> Aos Mith, Commscope, Mcs Frame.</span> </p>
                        </div>
                    </b-col>
                </b-row>                       
            </b-col>  

            <b-col  v-if="!(this.depName == 'Mantenimiento' ||this.depName == 'Vigueta'  ||this.depName == 'Insulpanel' || this.depName == 'Bono Garantía' ) && prod" class="bg-white p-4 col-6 adminPila pila-prod  mb-4" >
                <b-row class="produccion">
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #005cc3;"></div></b-col>
                    <b-col class="pl-3 pr-5 colprod">
                        <p class="stylingTitle">Producción </p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Lunes</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Martes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5" style="color: #838383;">Miércoles </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Jueves </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Viernes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Sábado</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Domingo</p></strong></th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1 " style="color: #fd832d;">
                                                     <template v-if="prod.lunes > 0"> {{prod.lunes | rand}}</template>
                                                    <template v-else>{{prod.lunes }}</template>    
                                                </li>
                                            </ul>
                                            
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">                                            
                                                     <template v-if="prod.martes > 0"> {{prod.martes | rand}}</template>
                                                    <template v-else>{{prod.martes }}</template>                                         
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="prod.miercoles > 0"> {{prod.miercoles | rand}}</template>
                                                    <template v-else>  {{prod.miercoles}}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="prod.jueves > 0"> {{prod.jueves | rand}}</template>
                                                    <template v-else> {{prod.jueves }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                   <template v-if="prod.viernes > 0"> {{prod.viernes | rand}}</template>
                                                    <template v-else>  {{prod.viernes }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="prod.sabado > 0"> {{prod.sabado | rand}}</template>
                                                    <template v-else>  {{prod.sabado }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="prod.domingo > 0"> {{prod.domingo | rand}}</template>
                                                    <template v-else>  {{prod.domingo }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                    </b-col>
                </b-row>                       
            </b-col> 
              <b-col  v-if="colaboradores" class="bg-white p-4 col-6 adminPila pila-prod  mb-4" >
                <b-row class="produccion">
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #ffc107;"></div></b-col>
                    <b-col class="pl-3 pr-5 colprod">
                        <p class="stylingTitle">Colaboradores</p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Lunes</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Martes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5" style="color: #838383;">Miércoles </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Jueves </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Viernes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Sábado</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Domingo</p></strong></th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1 " style="color: #fd832d;">
                                                     <template v-if="colaboradores.lunes > 0"> {{colaboradores.lunes | rand}}</template>
                                                    <template v-else>{{colaboradores.lunes }}</template>    
                                                </li>
                                            </ul>
                                            
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">                                            
                                                     <template v-if="colaboradores.martes > 0"> {{colaboradores.martes | rand}}</template>
                                                    <template v-else>{{colaboradores.martes }}</template>                                         
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="colaboradores.miercoles > 0"> {{colaboradores.miercoles | rand}}</template>
                                                    <template v-else>  {{colaboradores.miercoles}}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="colaboradores.jueves > 0"> {{colaboradores.jueves | rand}}</template>
                                                    <template v-else> {{colaboradores.jueves }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                   <template v-if="colaboradores.viernes > 0"> {{colaboradores.viernes | rand}}</template>
                                                    <template v-else>  {{colaboradores.viernes }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="colaboradores.sabado > 0"> {{colaboradores.sabado | rand}}</template>
                                                    <template v-else>  {{colaboradores.sabado }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="colaboradores.domingo > 0"> {{colaboradores.domingo | rand}}</template>
                                                    <template v-else>  {{colaboradores.domingo }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                    </b-col>
                </b-row>                       
            </b-col>  
             
            <b-col v-if="depName == 'Bono Garantía'" class="bg-white p-4 col-12 mb-4 adminPila2" >   
                <b-row>
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales <img  v-if=" user.role != '016' && user.role != '11705' && user.role != '11716' && user.role != '059' &&  user.role != '1001' && user.role != '1002'" :src="icono" @click="showBtn= !showBtn" class="icon float-right pt-1" alt="Edit icon"> </p>
                        <form @submit.prevent="submit_bg(monto)" >     
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputM">Monto Base</label>
                                <b-form-input 
                                   v-model="monto"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !monto && inputOnFocus, 'is-valid' : monto}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputM" 
                                    type="number" 
                                    :disabled="monto < 0 || user.role == '1001' || user.role == '1002' || user.role == '056'  ||  user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059' "
                                    :placeholder="monto | stringify"/>
                                  
                            </div>
                            
                            <small :class="{'text-danger' : !monto, 'd-none' : !inputOnFocus || monto}">
                                   * No puede haber campos vacíos
                                </small>
                            <button v-if="showBtn"
                            :class="['btn btn-block', { 'saved' : isAFlag, 'blue' : isAFlag == false }]"
                            class="mt-3"
                            type="submit"><img v-if="isAFlag" :src="check" class="icon mb-1 mr-1" /> {{textButton}}
                            </button>
                        </form>

                    </b-col>                            
                </b-row>                                                     
            </b-col>  

           
            <b-row  class="px-3 pt-3 pb-3" id="pilas-form-admin"  v-else-if="depName == 'Vigueta'">
                  
              <b-col class="bg-white p-4 col-12 mb-4 adminPila" >   
                <b-row>
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color:#6791fb;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales <img v-if="  user.role != '016' && user.role != '11705' && user.role != '11716' &&  user.role != '059' && user.role != '1001' && user.role != '1002'" :src="icono" @click="showBtn= !showBtn" class="icon float-right pt-1" alt="Edit icon"> </p>
                    
                        <form @submit.prevent="submit(base0, diasS, extra)" >     
                            
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputB0">Base 0</label>
                               <b-form-input 
                                   v-model="base0"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !base0  && inputOnFocus, 'is-valid' : base0 }]" 
                                    @blur="inputOnFocus = true"
                                    id="inputB0" 
                                    type="number" 
                                    :disabled="base0 < 0 || user.role == '1001' || user.role == '1002' || user.role == '056'   || user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="base0 | stringify"/>
                            </div>
                            <div class="input-group mb-3">
                                <label class="labelDS" for="inputDS">Dias sucios</label>
                                <b-form-input
                                    v-model="diasS"                                    
                                    required
                                    :class="['form-control',{'is-invalid' : !diasS && inputOnFocus, 'is-valid' : diasS}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputDS" 
                                    type="number" 
                                    :disabled="diasS < 0 || user.role == '1001' || user.role == '1002' ||user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="diasS"/>    
                            </div>
                            <div class="input-group mb-3">
                                <label class="mr-5" for="inputE">$ Extra por m3</label>
                                <b-form-input  
                                    v-model="extra"                                 
                                    required
                                    :class="['form-control', {'is-invalid' : !extra && inputOnFocus, 'is-valid' : extra}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputE" 
                                    type="number" 
                                    step=".01"
                                    :disabled="extra < 0 || user.role == '1001' || user.role == '1002' || user.role == '056'  || user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="extra"/>
                            </div>
                            <small :class="{'text-danger' : !base0, 'd-none' : !inputOnFocus || base0}">
                                   * No puede haber campos vacíos
                                </small>
                            <button v-if="showBtn"
                            :class="['btn btn-block', { 'saved' : isAFlag, 'blue' : isAFlag == false }]"
                            class="mt-3"
                            type="submit"><img v-if="isAFlag" :src="check" class="icon mb-1 mr-1" /> {{textButton}}
                            </button>
                        </form>

                    </b-col>                            
                </b-row>                            
                                                                    
              </b-col>   
               <b-col class="bg-white p-4 col-12 mb-2 adminPila2" >   
                <b-row>
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2">Monto base diario <img v-if="user.role != '016' && user.role != '11705' && user.role != '11716' &&  user.role != '059' && user.role != '1001' && user.role != '1002'" :src="icono" @click="showBtn2= !showBtn2" class="icon float-right pt-1" alt="Edit icon"> </p>
                        <form @submit.prevent="submit_bg(monto)" >     
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputM">Monto base</label>
                                <b-form-input 
                                   v-model="monto "                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !monto  && inputOnFocus, 'is-valid' : monto }]" 
                                    @blur="inputOnFocus = true"
                                    id="inputM" 
                                    type="number" 
                                    :disabled="monto < 0 || user.role == '1001' || user.role == '1002' || user.role == '056'  || user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="monto | stringify"/>
                            </div>
                            
                            <small :class="{'text-danger' : !monto , 'd-none' : !inputOnFocus || monto }">
                                   * No puede haber campos vacíos
                                </small>
                            <button v-if="showBtn2"
                            :class="['btn btn-block', { 'saved' : isAFlag, 'blue' : isAFlag == false }]"
                            class="mt-3"
                            type="submit"><img v-if="isAFlag" :src="check" class="icon mb-1 mr-1" /> {{textButton}}
                            </button>
                        </form>

                    </b-col>                            
                </b-row>                    
                                                                    
               </b-col>        
            </b-row >

            
                 
           
               <b-col class="bg-white p-4 col-12 mb-4 adminPila2"   v-else-if="depName == 'Insulpanel' && city=='Guadalajara'">   
                <b-row>
                    
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2">Datos extra <img v-if=" user.role != '016' && user.role != '11705' && user.role != '11716' && user.role != '059' && user.role != '1001' && user.role != '1002'" :src="icono" @click="showBtn2= !showBtn2" class="icon float-right pt-1" alt="Edit icon"> </p>
                        <form @submit.prevent="submit_bg(monto)" >     
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputB0">Monto base</label>
                                <b-form-input 
                                   v-model="monto"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !monto && inputOnFocus, 'is-valid' : monto }]" 
                                    @blur="inputOnFocus = true"
                                    id="inputB0" 
                                    type="number" 
                                    :disabled="monto < 0 || user.role == '1001' || user.role == '1002' || user.role == '056'  || user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="monto | stringify"/>
                            </div>
                            
                            <small :class="{'text-danger' : !monto, 'd-none' : !inputOnFocus || monto}">
                                   * No puede haber campos vacíos
                                </small>
                            <button v-if="showBtn2"
                            :class="['btn btn-block', { 'saved' : isAFlag, 'blue' : isAFlag == false }]"
                            class="mt-3"
                            type="submit"><img v-if="isAFlag" :src="check" class="icon mb-1 mr-1" /> {{textButton}}
                            </button>
                        </form>

                    </b-col>                            
                </b-row>                    
                                                                    
               </b-col>        
           
            
                 
             
               <b-col class="bg-white p-4 col-12 mb-4 adminPila" v-else-if="(depName == 'Insulpanel' && city=='Hermosillo')|| (depName == 'Insulpanel' && city=='Mexicali')" >   
                <b-row>
                    
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2">Montos base por nivel de carrera <img v-if="user.role != '016' && user.role != '11705' && user.role != '11716' && user.role != '059' && user.role != '1001' && user.role != '1002'" :src="icono" @click="showBtn2= !showBtn2" class="icon float-right pt-1" alt="Edit icon"> </p>
                        <form @submit.prevent="submit_InsH(monto.NI, monto.N1,monto.N2,monto.N3, monto.N4)" >  
                         
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputB0">NI</label>
                                <b-form-input 
                                   v-model="monto.NI"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !monto.NI && inputOnFocus, 'is-valid' : monto.NI}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputB0" 
                                    type="number" 
                                    :disabled="monto.NI < 0 || user.role == '1001' || user.role == '1002' || user.role == '056'  || user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="monto.NI | stringify"/>
                            </div>
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputB0">N1</label>
                                <b-form-input 
                                   v-model="monto.N1"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !monto.N1 && inputOnFocus, 'is-valid' : monto.N1}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputB0" 
                                    type="number" 
                                    :disabled="monto.N1 <0 || user.role == '1001' || user.role == '1002' || user.role == '056'  || user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="monto.N1 | stringify"/>
                            </div>
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputB0">N2</label>
                                <b-form-input 
                                   v-model="monto.N2"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !monto.N2 && inputOnFocus, 'is-valid' : monto.N2}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputB0" 
                                    type="number" 
                                    :disabled="monto.N2 < 0 || user.role == '1001' || user.role == '1002' || user.role == '056'  || user.role == '016'  || user.role == '11705' || user.role == '11716' ||user.role == '059'"
                                    :placeholder="monto.N2 | stringify"/>
                            </div>
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputB0">N3</label>
                                <b-form-input 
                                   v-model="monto.N3"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !monto.N3 && inputOnFocus, 'is-valid' : monto.N3}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputB0" 
                                    type="number" 
                                    :disabled="monto.N3 < 0 || user.role == '1001' || user.role == '1002' || user.role == '056' || user.role == '016' || user.role == '11705' || user.role == '11716' ||user.role == '059'"
                                    :placeholder="monto.N3 | stringify"/>
                            </div>
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputB0">N4</label>
                                <b-form-input 
                                   v-model="monto.N4"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !monto.N4 && inputOnFocus, 'is-valid' : monto.N4}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputB0" 
                                    type="number" 
                                    :disabled="monto.N4 < 0 || user.role == '1001' || user.role == '1002' || user.role == '056' || user.role == '016' || user.role == '11705' || user.role == '11716' ||user.role == '059'"
                                    :placeholder="monto.N4 | stringify"/>
                            </div>
                          
                            
                            <small :class="{'text-danger' : !monto.NI, 'd-none' : !inputOnFocus || monto_NI}">
                                   * No puede haber campos vacíos
                                </small>
                            <button v-if="showBtn2"
                            :class="['btn btn-block', { 'saved' : isAFlag, 'blue' : isAFlag == false }]"
                            class="mt-3"
                            type="submit"><img v-if="isAFlag" :src="check" class="icon mb-1 mr-1" /> {{textButton}}
                            </button>
                        </form>

                    </b-col>                            
                </b-row>                    
                                                                    
               </b-col>        
          
          
            <b-col v-else-if="!(this.depName == 'Mantenimiento')" class="bg-white p-4 col-12 mb-4 adminPila" >   
                <b-row>
                   
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales <img v-if="user.role != '016' && user.role != '11705' && user.role != '11716' && user.role != '059' && user.role != '1001' && user.role != '1002'" :src="icono" @click="showBtn= !showBtn" class="icon float-right pt-1" alt="Edit icon"> </p>
                        <form @submit.prevent="submit(base0, diasS, extra)" >     
                            <div class="input-group mb-3">                                
                                <label class="labelB0" for="inputB0">Base 0</label>
                                <b-form-input 
                                    v-model="base0"                                     
                                    required
                                    :class="['form-control',{'is-invalid' : !base0 && inputOnFocus, 'is-valid' : base0}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputB0" 
                                    type="number" 
                                    :disabled="base0 < 0  || depName=='Mantenimiento' || user.role == '1001' || user.role == '1002' || user.role == '056'  || user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="base0 | stringify"/>
                            </div>
                            <div class="input-group mb-3">
                                <label class="labelDS" for="inputDS">Dias sucios</label>
                                <b-form-input
                                    v-model="diasS"                                    
                                    required
                                    :class="['form-control',{'is-invalid' : !diasS && inputOnFocus, 'is-valid' : diasS}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputDS" 
                                    type="number" 
                                    :disabled="diasS < 0 || depName=='Mantenimiento' || user.role == '1001' || user.role == '1002'  || user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="diasS"/>    
                            </div>
                            <div class="input-group mb-3">
                                <label class="mr-5" for="inputE">$ Extra por m3</label>
                                <b-form-input  
                                    v-model="extra"                                 
                                    required
                                    :class="['form-control', {'is-invalid' : !extra && inputOnFocus, 'is-valid' : extra}]" 
                                    @blur="inputOnFocus = true"
                                    id="inputE" 
                                    type="number" 
                                    step=".01"
                                    :disabled="extra < 0 || depName=='Mantenimiento' || user.role == '1001' || user.role == '1002' || user.role == '056'  ||  user.role == '016' || user.role == '11705' || user.role == '11716' || user.role == '059'"
                                    :placeholder="extra"/>
                            </div>
                            <small :class="{'text-danger' : !base0, 'd-none' : !inputOnFocus || base0}">
                                   * No puede haber campos vacíos
                                </small>
                            <button v-if="showBtn"
                            :class="['btn btn-block', { 'saved' : isAFlag, 'blue' : isAFlag == false }]"
                            class="mt-3"
                            type="submit"><img v-if="isAFlag" :src="check" class="icon mb-1 mr-1" /> {{textButton}}
                            </button>
                        </form>

                    </b-col>                            
                </b-row>                                                     
            </b-col>
            
            <b-col class="bg-white p-4 col-6 mb-4 adminPila" >
                <b-row>
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #00c290;"></div></b-col>
                    <b-col class="pl-3">
                        <p class="stylingTitle">Colaboradores </p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Nombre: </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Bono al día: </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Asistencia: </p></strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul>
                                                <li v-for="item in equipo" :key="item.id" class="stylingSmall mb-1">
                                                    <router-link :to="link(item.num)">{{item.nombre | cap }} </router-link>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul style="list-style-type: none;">
                                                <li v-for="item in bono" :key="item.id" class="stylingSmall mb-1" style="color: #fd832d;">                                            
                                                    <template v-if="item">$ {{item | rand }}</template>
                                                    <template v-else>$ 0</template>                                                    
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul style="list-style-type: none;">
                                                <li v-for="item in asistencia" :key="item.id" class="stylingSmall mb-1" style="color: #fd832d;">
                                                    {{item}}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                    </b-col>
                </b-row>                       
            </b-col>

            

            
                
              
            
        </b-row>      

      
</div>

</div>

   
</template>


<script>
import HistorialSemanas from './historialSemanas.vue'
import HistorialSemanasDinamica from './historialSemanasDinamica.vue'
import icono from '../assets/icono_edit.png';
import check from '../assets/icono_check.png';
import moment from 'moment';

import { mapActions } from "vuex";
export default {
    name: 'FormInfoBase',
    components:{
        HistorialSemanas,
        HistorialSemanasDinamica
    },
    props: {
        equipo:{
            required: true
        },
        extra:{
            required: true
        },
        diasS:{
            required: true
        },
        base0:{
            required: true
        },
        bono:{
            required: true
        },
        asistencia:{
            required: true
        },
        statusDepto:{
            required: true
        },
         monto:{
            required: false
        },
        prod:{
            required: false
        },
        areas:{
            required:false
        },
        montos_areas:{
            required:false
        },
        lastweek:{
            required:false
        },
        historial:{
            required:false
        },
        colaboradores:{
            required:false
        }
    },
    data() {
        return {
            fecha:'',
            base:'',
            monto_base: 0,
            monto_NI:0,
            monto_N1:0, 
            monto_N2:0,
            monto_N3:0,
            dias_sucios: '',
            extra_m3: '',
            icono: icono,
            showBtn: false,
            showBtn2: false,
            check: check,
            inputOnFocus: false,
            valid: false,
            btnsemana:'Actual',
            dinweek:'Dinamica',
            dinweek2:'2',
            query:`nada`
        }
    },
    mounted(){
 
        if(this.monto != undefined){
            this.monto_base= this.monto
        }

        if(this.monto != undefined){
            this.monto_NI = this.monto.NI
            this.monto_N1 = this.monto.N1
            this.monto_N2 = this.monto.N2
            this.monto_N3 = this.monto.N3
        }

        if(this.base0 !=undefined){
            this.base = this.base0
        }

        if(this.diasS != undefined){
            this.dias_sucios = this.diasS
        }

        if(this.extra != undefined){
            this.extra_m3 = this.extra
        }
    
    },
    created() {
    
    this.getQuery('get_qry');
    
  },


    computed: {
        isAFlag() {
            return this.$store.getters['plants/flag'];
        },
        textButton() {
            return this.$store.getters['plants/getNotif'];
        },
        depName() {
            return this.$store.getters["admin/getDep"];
        },
        city(){
            return this.$store.getters['admin/getName'];
        },
         dataquery(){
            return this.$store.getters['querys/data'];
        },
        depto() {
          //  console.log(this.$store.getters['plants/data'])
            return this.$store.getters['plants/data'];
        },
        bd() {
            return this.$store.getters['plants/bd'];
        },
        user() {
        return this.$store.getters['userService/getIdentity'];
        },
        
    },
    methods: {
         ...mapActions("querys", ["getQuery"]),
        replace:function(query){
           return  query.replaceAll('fecha','${dia}')
            
        },
          validateDia(){
             let  valid = false 
             let dia = moment().day()
             let hora = moment().hour()
           
            if( dia == 1 && hora < 11 ){ // lunes antes de las 11 no se podra editar.
                valid = true;
            }
            

             return valid
         },
        editarQuery: async function(query){
            let user = this.user.name +'-'+ this.user.num
            let result = await this.$store.dispatch("querys/editQuery",  {data:query, user: user});
            this.wait()
        },
        editInfo: function (base, dias_sucios, extra_m3) {
            let city = this.$store.getters['admin/getName'];
            let dep = this.depName;           
            console.log(city)
            let linkdepto = dep.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");
            let linkcity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");            
            this.$store.dispatch('plants/editInfo', {
                base: base,
                dias_sucios: dias_sucios,
                extra_m3: extra_m3,
                depto: linkdepto,
                city: linkcity
            });
        },
        wait: function(){
            setTimeout(() => this.$router.go(), 1000);
        },
        validate: function (base, dias_sucios, extra_m3) {
            this.inputOnFocus = true;
            if (base && dias_sucios && extra_m3) {
                this.valid = true;
            }
        },
        submit: function(base, dias_sucios, extra_m3) {      
            this.validate(base, dias_sucios, extra_m3);
            if (this.valid) {      
                base = parseInt(base)       
                this.editInfo(base, dias_sucios, extra_m3);
                this.wait();
            }
        },
        editMontoBase: function (monto_base) {
            let city = this.$store.getters['admin/getName'];
            let dep = this.depName;           
            let linkdepto = dep.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");
            let linkcity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");            
            this.$store.dispatch('plants/editMontoBase', {
                monto_base: monto_base,
                depto: linkdepto,
                city: linkcity
            });
        },
        validate_bg: function (monto_base) {
            this.inputOnFocus = true;
            if (monto_base) {
                this.valid = true;
            }
        },
        submit_bg: function(monto_base) {
            this.validate_bg(monto_base);
            if (this.valid) {                
                this.editMontoBase(monto_base);
                this.wait();
            }
        },
        validate_InsH: function (monto_NI, monto_N1,monto_N2,monto_N3, monto_N4) {
            this.inputOnFocus = true;
            if (monto_NI && monto_N1 && monto_N2 && monto_N3 && monto_N4 ) {
                this.valid = true;
            }
        },
        submit_InsH: function(monto_NI, monto_N1,monto_N2,monto_N3, monto_N4) {
            this.validate_InsH(monto_NI, monto_N1,monto_N2,monto_N3, monto_N4);
            console.log('hola')
            if (this.valid) {                
                this.editMontoBaseNC(monto_NI, monto_N1,monto_N2,monto_N3, monto_N4);
                this.wait();
            }
        },
        editMontoBaseNC: function (monto_NI, monto_N1,monto_N2,monto_N3, monto_N4) {
            let city = this.$store.getters['admin/getName'];
            let dep = this.depName;           
            let linkdepto = dep.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");
            let linkcity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");     
            let monto_base ={
                NI: monto_NI,
                N1: monto_N1,
                N2: monto_N2,
                N3: monto_N3,
                N4: monto_N4
            }       
            this.$store.dispatch('plants/editMontoBase', {
                monto_base: monto_base,
                depto: linkdepto,
                city: linkcity
            });
        },
        link: function (user) {
            let city = this.$store.getters['admin/getName'];
            let dep = this.depName
            let linkcity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
            let linkdepto = dep.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");
            return '/'+linkcity+'/'+linkdepto+'/'+user ;
        },
        ChangeWeek: function(value){
                this.fecha =''
                this.btnsemana = value
        
        },
         smn: function (value){
            if (!value) return '';
             value = value.toString();
             let splitStr = value.split(' a ');

             return splitStr[1]
        },

          getWeek2:async function(fecha){
            
                let city = this.city
                city = city.normalize("NFD").replace(/[\u0300-\u036f-\s]/g, "");
                city == 'LaPaz' ? city='La Paz' : city
    

                let payload ={
                    depto: this.depName,
                    ciudad: city,
                    semana: fecha
                }

              let result = await  this.$store.dispatch('plants/getWeek', payload);
             
 
              this.dinweek2 =  result.result
               this.btnsemana ='2'
 
        },

        getWeek:async function(){
             if(this.fecha != ''){
                let date =this.fecha
              
                let day = moment(date).day()

                let desc=''
                let mes='';
                let mes2='';
                let lunes='';
                let domingo='';

                if(day==1){   
                mes  = moment(date).locale('es').format('MMMM')
                lunes = moment(date).format('DD')

                domingo = moment(date).add(6,'days').format('DD')
                mes2  = moment(date).locale('es').add(6,'days').format('MMMM')
                }else if(day==2){
                mes  = moment(date).locale('es').subtract(1,'days').format('MMMM')
                lunes = moment(date).subtract(1,'days').format('DD')

                domingo = moment(date).add(5,'days').format('DD')
                mes2  = moment(date).locale('es').add(5,'days').format('MMMM')
                
                }else if(day==3){
                mes  = moment(date).locale('es').subtract(2,'days').format('MMMM')
                lunes = moment(date).subtract(2,'days').format('DD')

                domingo = moment(date).add(4,'days').format('DD')
                mes2  = moment(date).locale('es').add(4,'days').format('MMMM')
                }else if(day==4){
                    mes  = moment(date).locale('es').subtract(3,'days').format('MMMM')
                lunes = moment(date).subtract(3,'days').format('DD')

                domingo = moment(date).add(3,'days').format('DD')
                mes2  = moment(date).locale('es').add(3,'days').format('MMMM')
                
                }else if(day==5){
                    mes  = moment(date).locale('es').subtract(4,'days').format('MMMM')
                lunes = moment(date).subtract(4,'days').format('DD')

                domingo = moment(date).add(2,'days').format('DD')
                mes2  = moment(date).locale('es').add(2,'days').format('MMMM')
                
                }else if(day==6){
                    mes  = moment(date).locale('es').subtract(5,'days').format('MMMM')
                lunes = moment(date).subtract(5,'days').format('DD')

                domingo = moment(date).add(1,'days').format('DD')
                mes2  = moment(date).locale('es').add(1,'days').format('MMMM')
                
                }else if(day==0){
                mes  = moment(date).locale('es').subtract(6,'days').format('MMMM')
                lunes = moment(date).subtract(6,'days').format('DD')

                domingo = moment(date).format('DD')
                mes2  = moment(date).locale('es').format('MMMM')
                }


                mes = mes.charAt(0).toUpperCase() + mes.slice(1); //poner en mayus la primera letra
                mes2 = mes2.charAt(0).toUpperCase() + mes2.slice(1);

                desc= 'Lunes '+lunes+ ' de ' + mes + ' a Domingo '+domingo+ ' de '+ mes2

               
                
                let city = this.city
                city = city.normalize("NFD").replace(/[\u0300-\u036f-\s]/g, "");
                city == 'LaPaz' ? city='La Paz' : city
               

                let payload ={
                    depto: this.depName,
                    ciudad: city,
                    semana: desc
                }

              let result = await  this.$store.dispatch('plants/getWeek', payload);
             
             this.dinweek = result.result
              this.btnsemana ='Dinamica'


                


             }else{
                  alert('Seleccione una fecha.')
             }
        },

        day(){
             let day = moment().weekday()

            if(day==1){   
            return moment().subtract(8,'days').format('yyyy-MM-DD')
            }else if(day==2){
            return moment().subtract(9,'days').format('yyyy-MM-DD')  
            }else if(day==3){
            return moment().subtract(10,'days').format('yyyy-MM-DD')
            }else if(day==4){
            return moment().subtract(11,'days').format('yyyy-MM-DD') 
            }else if(day==5){
            return moment().subtract(12,'days').format('yyyy-MM-DD')
            }else if(day==6){
            return moment().subtract(13,'days').format('yyyy-MM-DD')
            }else if(day==0){
            return moment().subtract(14,'days').format('yyyy-MM-DD')
            }
        }


    },
    filters:{
        rand: (value) => {
            if (!value) return '';
            if (typeof value === 'number') {
                return value.toFixed(2);
            }
            return value;
        },
        stringify: (value) => {
            if(!value) return '0';
            if (typeof value == 'number'){
                return value.toString();
            }
        },
        cap: (value) => {
            if (!value) return '';
            value = value.toString();
            let splitStr = value.toLowerCase().split(' ');
            let len = splitStr.length
            let i; 
            for (i = 0; i < len; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            let nameCap = splitStr.join(' '); 
            return nameCap;
        }
    }
}
</script>
<style scoped>
.active {
     background-color: #fe9136 !important;
    border-color: #fe9136 !important;
}

.square1{
    height: 10.5px;
    width: 10.5px;
    margin-top: 3.4px;
}
.icon{
    max-width: 1rem;
    cursor: pointer;
}
input#inputB0,
input#inputDS,
input#inputE,
input#inputM{
    font-family: 'FuturaPTMedium';
    border-color: #d2d6dd;
    min-width: 80px;
    border-radius: 7px;
    color: #fd832d
}
label{
    font-family: 'FuturaPTMedium';
    color: #838383 !important;
    font-size: 95% !important;
    font-weight: 100 !important;
}
.stylingTitle{
    font-family: 'FuturaPTMedium';
    color: #bcbcbc;
    font-size: 1rem;
}
.labelB0{
    margin-right: 6rem;
}
.labelDS{
    margin-right: 4.5rem;
}
::placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
:-ms-input-placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
::-ms-input-placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.adminPila{
    min-height: 15rem;
    min-width: 100%;
}

.adminPila2{
    min-height: 10rem;
    min-width: 100%;
}
ul{
    padding: 0;
    padding-left: 1rem;
    font-size: small;
}
.blue {
    background-color: #4d78e7;
    border-radius: 20px;
    font-size: 14px;
    font-family: 'FuturaPTMedium';
    padding: 11px 0px;
    color: white;
}
.blue:hover{
    background-color: #3b63c9;
}
.saved{
    background-color: white;
    border: 1px solid #3b63c9;
    color: #3b63c9;
    border-radius: 20px;
    font-size: 14px;
    font-family: 'FuturaPTMedium';
    padding: 11px 0px;
}
li >>> a {
    color: #838383;
}
@media (max-width: 420px) { 
    div.inactive-class img{
        margin-left: -2rem;
    }
    div.inactive-class h5{
        margin-right:2rem;
        font-size:.9rem;
    }
}
@media (max-width: 527px) { 
    div.inactive-class h5{
        margin-right:2rem;
    }
}
</style>